import {
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 64px;
  margin-bottom: 32px;
  h2 {
    text-align: center;
  }
`;

export const Image = styled.img`
  width: 100%;
  display: none;

  @media (min-width: 768px) {
    width: 50vw;
    display: flex;
    height: 80vh;
    object-fit: cover;
    display: flex;
  }
`;

export const StyledAccordionButton = styled(AccordionItemButton)<{
  color?: string;
}>`
  padding: 16px 16px 16px 16px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }
  div p {
    color: ${(props) => (props.color ? props.color : "var(--primary)")};
    font-family: "Roboto", sans-serif !important;
    font-size: 22px !important;
    font-weight: 500 !important;
    @media (min-width: 768px) {
      font-size: 22px !important;
      font-weight: 600 !important;
    }
  }
`;

export const StyledAccordionPannel = styled(AccordionItemPanel)<{
  color?: string;
}>`
  padding: 8px 16px 8px 16px;
`;

export const Divider = styled.hr`
  width: 100%;
`;

export const FAQWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;

  div {
    width: 100%;
    text-align: start;
  }
  img {
    width: 100%;
    display: none;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    width: 90%;
    align-self: center;
    gap: 5%;
    img {
      width: 100%;
      display: flex;
    }
  }
`;
